import { useState, useEffect } from 'react'

export function HandleSingleAndDoubleClick(
  actionSingleClick,
  actionDoubleClick,
  delay = 250
) {
  const [click, setClick] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      // simple click
      if (click === 1) actionSingleClick()
      setClick(0)
    }, delay)

    // If the duration between this click and the previous click
    // is less than the value of delay...
    // trigger the double-click action, and
    // stop the single-click action
    if (click === 2) actionDoubleClick()

    return () => clearTimeout(timer)
  }, [actionDoubleClick, actionSingleClick, click, delay])

  return () => setClick(prev => prev + 1)
}
